












































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountCreateMemberRequestModel from '@/models/bankaccounts/BankAccountCreateMemberRequestModel';

@Component({
        name: 'BankAccountCreateMember',
    },
)
export default class BankAccountCreateMember extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public authorized: boolean = false;
    public emailAddress: string = '';
    public roleTypeId: string = '2';

    public emailRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'An email address is required.';
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.CREATE_MEMBER )
        {
            this.authorized = true;
        }
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new BankAccountCreateMemberRequestModel();
                request.inviteeMemberEmailAddress = this.emailAddress;
                request.roleTypeId = parseInt(this.roleTypeId, 10);

                const api = new BankAccountsApi();
                const response = await api.createMemberAsync(this.bankAccountId, this.$store.state.member.jwt, request);

                await this.$router.push({name: 'bankaccountdashboard', params: { bankAccountId: this.bankAccountId.toString(10)}});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.createMemberForm;

        return form.validate();
    }

}

